import PageHeader from '../layout/PageHeader'
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate'
import PageContainer from '../layout/PageContainer'
import DataTable from '../dataTable/DataTable'
import StoreKeyProvider from '../../providers/StoreKeyProvider'
import WithFilters from '../../hocs/WithFilters'
import { Card, CardContent, Button, CardHeader } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { useDispatch } from 'react-redux'
import { openPopup } from '../../../store/popupsSlice'
import { useEffect, useState } from 'react'
import DataInputs from '../dataTable/DataInputs'
import axios from 'axios'

const Events = () => {
  const dispatch = useDispatch()

  const [genders, setGenders] = useState([])
  const [medical_care, setMecicalCare] = useState([])
  // const [medicalFacilities, setMedicalFacilityName] = useState([])
  const [contract_types, setTypeName] = useState([])
  const [admins, setPwz] = useState([])
  const [examinations, setExaminations] = useState([])

  useEffect(() => {
    axios.post('/lookups/genders', null).then((res) => {
      setGenders(res.data)
    }),
      axios.post('/lookups/medical_care', null).then((res) => {
        setMecicalCare(res.data)
      }),
      // axios.post('/lookups/medical_facilities', null).then((res) => {
      //   setMedicalFacilityName(res.data)
      // }),
      axios.post('/lookups/contract_types', null).then((res) => {
        setTypeName(res.data)
      }),
      axios.post('/admins', null).then((res) => {
        setPwz(res.data)
      })
    axios.post('/lookups/examinations/list', null).then((res) => {
      setExaminations(res.data)
    })
  }, [])

  return (
    <>
      <PageHeader
        icon={<AssignmentLateIcon fontSize="large" />}
        title="Zdarzenia"
        subtitle="Tutaj znajdziesz listę wszystkie zdarzeń w systemie"
      />
      <PageContainer>
        <StoreKeyProvider storeKey="EventsKey">
          <WithFilters
            config={{
              page: 1,
              paginate: 10,
              orderType: 'desc',
              order: 'created_at',
              inputs: {
                pesel: {
                  value: '',
                  relation: 'LIKE',
                },
                firstname: {
                  values: '',
                  relation: 'LIKE',
                },
                lastname: {
                  value: '',
                  relation: 'LIKE',
                },
                doctor_name: {
                  value: '',
                  relation: 'LIKE',
                },
                pwz: {
                  value: '',
                  relation: 'LIKE',
                },
                min_created_at: {
                  value: null,
                  relation: 'MIN',
                },
                max_created_at: {
                  value: null,
                  relation: 'MAX',
                },
                medical_care_id: {
                  value: '',
                  relation: 'WHERE',
                },
                // medical_facility_id: {
                //   value: '',
                //   relation: 'WHERE',
                // },
                // min_summary_price: {
                //   value: null,
                //   relation: 'MIN',
                // },
                // max_summary_price: {
                //   value: null,
                //   relation: 'MAX',
                // },
                type_id: {
                  value: null,
                  relation: 'WHERE',
                },
                examination_id: {
                  value: null,
                  relation: 'WHERE',
                },
              },
            }}
            endpoint="/contracts/incidents"
          >
            <Card elevation={2} square>
              <CardHeader
                title="Lista zdarzeń"
                action={
                  <Button
                    startIcon={<AddIcon />}
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      dispatch(
                        openPopup({
                          component: 'ContractFactory',
                          title: 'Dodaj zlecenie',
                          level: 1,
                          maxWidth: 'xl',
                          key: 'contract-factory-popup',
                          values: {
                            event: true,
                          },
                        })
                      )
                    }
                  >
                    Dodaj
                  </Button>
                }
              ></CardHeader>
              <CardContent>
                {genders && medical_care && admins && (
                  <DataInputs
                    inputs={[
                      {
                        id: 'pesel',
                        label: 'PESEL',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'firstname',
                        label: 'Imię',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'lastname',
                        label: 'Nazwisko',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'doctor_name',
                        label: 'Lekarz',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'pwz',
                        label: 'Nr. PWZ',
                        placeholder: '',
                        type: 'select',
                        options: admins,
                        config: {
                          key: 'id',
                          label: 'firstname+lastname+pwz',
                          separator: [' ', ' - '],
                        },
                      },
                      {
                        id: 'created_at',
                        label: 'Data utworzenia',
                        placeholder: '',
                        type: 'date-between',
                      },
                      {
                        id: 'medical_care_id',
                        label: 'Opieka medyczna',
                        placeholder: '',
                        type: 'select',
                        options: medical_care,
                      },
                      // {
                      //   id: 'medical_facility_id',
                      //   label: 'Placówka medyczna',
                      //   placeholder: '',
                      //   type: 'select',
                      //   size: 2,
                      //   options: medicalFacilities,
                      //   config: {
                      //     key: 'id',
                      //     label: 'name+nip+address',
                      //     separator: ' - ',
                      //   },
                      // },
                      // {
                      //   id: 'summary_price',
                      //   label: 'Cena',
                      //   placeholder: '',
                      //   type: 'number-between',
                      // },
                      {
                        id: 'type_id',
                        label: 'Typ zdarzenia',
                        placeholder: '',
                        type: 'select',
                        options: contract_types,
                      },
                      {
                        id: 'examination_id',
                        label: 'Badanie',
                        placeholder: '',
                        type: 'select',
                        options: examinations,
                      },
                    ]}
                  />
                )}
                <DataTable
                  breakpoint={1601}
                  actions="EventsTableActions"
                  labels={[
                    'Pesel',
                    'Imię',
                    'Nazwisko',
                    'Lekarz',
                    'Nr. PWZ',
                    'Data wykonania',
                    'Opieka medyczna',
                    // 'Placówka medyczna',
                    // 'Cena',
                    'Typ zdarzenia',
                  ]}
                  keys={[
                    'pesel',
                    'firstname',
                    'lastname',
                    'doctor_name',
                    'pwz',
                    'created_at',
                    'medical_care_name',
                    // 'medical_facility_name',
                    // 'summary_price',
                    'type_name',
                  ]}
                />
              </CardContent>
            </Card>
          </WithFilters>
        </StoreKeyProvider>
      </PageContainer>
    </>
  )
}

Events.propTypes = {}

export default Events
